import React, { useState } from "react";
import "../styles/vars.scss";
import Buttonz from "../ui/atoms/Buttonz";
import Inputz from "../ui/atoms/Inputz";
import DropDownz from "../ui/atoms/DropDownz";
import CountryDropDown from "../ui/atoms/DropDownzCountry";
import TextAreaz from "../ui/atoms/TextAreaz";
import Switchz from "../ui/atoms/Switchz";
import SvgIcn from "../data/IconCompo";
import Radioz from "../ui/atoms/Radioz";
import Popupz from "../ui/atoms/Popupz";
import CheckZ from "../ui/atoms/CheckZ";
import NavButtonz from "../ui/atoms/NavButtonz";
import CheckBtn from "../ui/atoms/CheckBtnZ";
import TagZ from "../ui/atoms/TagZ";
import TagButtonZ from "../ui/atoms/TagButtonZ";




function DesignSystem() {
  const [selectedValue, setSelectedValue] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [checkedValues, setCheckedValues] = useState({
    option1: false,
    option2: false,
    option3: false,
  });

  const handleRadioChange = (value) => {
    setSelectedValue(value); 
  };

  const handleCheckboxChange = (option) => {
    setCheckedValues((prev) => ({
      ...prev,
      [option]: !prev[option],
    }));
  };

  return (
    <div className="ds-hero">
      <h4>
        HOME
        <br />
        08/11/2024
        <SvgIcn name="cal" />
      </h4>
      {/* - - - - - - - - - BUTTONS - - - - - - - - - */}
      <div className="ds-box">
        <h2>BUTTONS</h2>
        <Buttonz
          iconL="mail"
          iconR="trash"
          hoverL="trash"
          hoverR="mail"
          label="Toppage"
          to="/"
        />
        <Buttonz label="Playground" iconR="mail" hoverR="cal"  to="playground"/>
        <Buttonz label="Signup" iconR="mail" hoverR="cal"  to="signup"/>
        <Buttonz label="Setting" iconR="mail" hoverR="cal"  to="setting"/>
        <Buttonz
          label="Components"
          iconR="mail"
          hoverR="cal"
          iconL="user"
          hoverL="cal"
          className="lined"
          to="Compoz"
        />
      </div>
      {/* - - - - - - - - - NAV BUTTON - - - - - - - - - */}
      <div className="ds-box ds-box-row">
        <h2>NAV BUTTON</h2>
        <NavButtonz icon="company" hover="company_ani" label="Label" />
        <NavButtonz icon="right_arrow" hover="right_arrow_ani" label="Label" />
        <NavButtonz icon="hand2" label="Label" />
        <NavButtonz icon="edit" hover="edit_ani" />
        <NavButtonz icon="pin_in" hover="pin_in_ani" />
        <NavButtonz icon="money" />
      </div>
      {/* - - - - - - - - - INPUTS - - - - - - - - - */}
      <div className="ds-box">
        <h2>INPUTS</h2>
        <Inputz
          iconL="user"
          focusL="cal"
          iconR="clear"
          focusR="cal"
          hoverIconR="mail"
          placeholder="Username1"
        />
        <Inputz
          iconL="user"
          focusL="cal"
          iconR="clear"
          focusR="cal"
          hoverIconR="mail"
          placeholder="Username"
          className="custom-class"
          buttonIcon="mail"
          buttonHoverIcon="cal"
          buttonLabel="GOO"
          buttonClass="custom-button-class"
        />
      </div>
      {/* - - - - - - - - - DROPDOWN - - - - - - - - - */}
      <div className="ds-box">
        <h2>DROPDOWN</h2>
        <DropDownz
          iconL="hum"
          focusL="dots_on"
          iconR="drop_down"
          iconRHover="drop_up"
          iconClear="clear"
          focusR="cal"
          hoverIconR="mail"
          placeholder="Select"
          className="custom-input"
        >
          <span>Grape</span>
          <span>Mango</span>
          <span>Pineapple</span>
          <span>Strawberry</span>
          <span>Blueberry</span>
          <span>Raspberry</span>
          <span>Kiwi</span>
        </DropDownz>
      </div>
      {/* - - - - - - - - - COUNTRY DROPDOWN - - - - - - - - - */}
      <div className="ds-box">
        <h2>COUNTRY DROPDOWN</h2>
        <CountryDropDown
          iconL="flag"
          iconRHover="cal"
          iconR="clear"
          placeholder="Select"
          
        />
      </div>
      {/* - - - - - - - - - TEXT AREA - - - - - - - - - */}
      <div className="ds-box">
        <h2>TEXT AREA</h2>
        <TextAreaz
          title="Your Message"
          iconL="user"
          placeholder="Placeholder"
          maxLength={100}
        />
        <TextAreaz
          className="insider"
          title="Your Message"
          iconL="user"
          placeholder="Placeholder"
          maxLength={500}
        />
      </div>

      {/* - - - - - - - - - SWITCH - - - - - - - - - */}
      <div className="ds-box">
        <h2>SWITCH</h2>
        <Switchz
          hintText="Switch Language"
          hintIcon="flag"
          onText="JP"
          offText="EN"
          width="60px"
          onIcon="ok"
          // offIcon="ok"
          direction="row-reverse"
        />
        <Switchz hintText="Agree?" width="48px" />
      </div>
      {/* - - - - - - - - - RADIO BUTTON - - - - - - - - - */}
      <div className="ds-box">
        <h2>RADIO BUTTON</h2>
        <Radioz
          name="radio-group"
          value="option1"
          checked={selectedValue === "option1"}
          onChange={handleRadioChange}
          label="Option 1"
          icon="mail"
        />
        <Radioz
          name="radio-group"
          value="option2"
          checked={selectedValue === "option2"}
          onChange={handleRadioChange}
          icon="mail"
        />
        <Radioz
          label="Option 3"
          value="option3"
          checked={selectedValue === "option3"}
          onChange={handleRadioChange}
        />
      </div>
      {/* - - - - - - - - - CHECKBOXE - - - - - - - - - */}
      <div className="ds-box">
        <h2>CHECKBOXE</h2>
        <CheckZ
          label="Option 1"
          checked={checkedValues.option1}
          onChange={() => handleCheckboxChange("option1")}
          icon="ok"
        />
        <CheckZ
          label="Option 2"
          checked={checkedValues.option2}
          onChange={() => handleCheckboxChange("option2")}
          icon="mail"
        />
        <CheckZ
          label="Option 3"
          checked={checkedValues.option3}
          onChange={() => handleCheckboxChange("option3")}
          icon="cal"
        />
      </div>

            {/* - - - - - - - - - CHECKBOTTON - - - - - - - - - */}
            <div className="ds-box">
        <h2>CHECKBOTTON</h2>
        <CheckBtn
          iconOn="ok"
          iconOff="close"

        />
      </div>


            {/* - - - - - - - - - TAGS - - - - - - - - - */}
            <div className="ds-box">
        <h2>TAGS</h2>
        <TagZ
        label="Static Tag"
        />
        <TagButtonZ
        label="Dynamic Tag"
        />
      </div>


      {/* - - - - - - - - - POPUP - - - - - - - - - */}
      <div className="ds-box">
        <h2>POPUP</h2>
        {showPopup && (
          <Popupz
            title="Popup Title"
            icon="mail"
            text="Popup Text"
            onClose={() => setShowPopup(false)}
          >
            <div>
              <p>This is an example of children content inside the popup.</p>
              <Buttonz
                label="Close"
                iconR="mail"
                hoverR="cal"
                onClick={() => setShowPopup(false)}
                className="lined"
              />
            </div>
          </Popupz>
        )}
        <Buttonz
          label="Open Popup"
          iconR="mail"
          hoverR="cal"
          onClick={() => setShowPopup(true)}
          className="lined"
        />
      </div>
    </div>
  );
}

export default DesignSystem;
